<div class="modal-header" *ngIf="showAsDialog" ngxModalDraggable>
    <h4 class="modal-title">Order Detail</h4>
</div>
<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!order && ready">
    <div class="card">
        <div class="card-body p-2 pb-3">
            <div class="btn-toolbar mx-0 mb-0 mt-0">
                <div>
                    <button (click)="save()" class="btn btn-sm btn-primary me-2" *ngIf="hasChanges() && !showAsDialog">Save</button>
                    <button (click)="cancel()" class="btn btn-sm btn-success me-4" *ngIf="hasChanges() && !showAsDialog">Cancel</button>
                    <button (click)="close()" class="btn btn-sm btn-primary me-4" *ngIf="!hasChanges() && !showAsDialog">Close</button>
                    <button (click)="email()" class="btn btn-sm btn-success me-2" *ngIf="!hasChanges()" [hidden]="order.statusId === Statuses.New || showAsDialog">
                        Email Sales Order
                    </button>
                    <button *ngIf="!hasChanges() && isQuote" class="btn btn-sm btn-success ms-3" (click)="email()">Email Quote</button>
                    <button *ngIf="!hasChanges() && isQuote" class="btn btn-sm btn-secondary ms-3" (click)="print()">Print Quote</button>
                    <button (click)="emailMsrps()" class="btn btn-sm btn-success me-2" *ngIf="!hasChanges()" [hidden]="order.statusId === Statuses.New || showAsDialog">
                        Email MSRPs
                    </button>
                    <button
                        (click)="print()"
                        class="btn btn-sm btn-secondary me-4"
                        *ngIf="!hasChanges()"
                        [hidden]="(order.statusId !== 2 && order.statusId !== 3 && order.statusId !== 6) || showAsDialog"
                    >
                        Print Sales Order
                    </button>
                    <button (click)="auditLog()" class="btn btn-sm btn-info ms-auto" *ngIf="!hasChanges() && !showAsDialog && !isQuote">Audit Log</button>
                    <button *ngIf="!hasChanges() && !showAsDialog && !achInfo && canApplyACH && canSeeACH" (click)="applyAch()" class="btn btn-sm btn-danger ms-4">
                        Apply ACH Pricing
                    </button>
                    <label *ngIf="!!achInfo" class="ms-4 me-4">{{ achInfo }}</label>
                    <button
                        *ngIf="!!canUnApplyACH && !!achInfo && !hasChanges()"
                        class="btn btn-sm btn-danger ms-2"
                        (click)="unapplyAch()"
                        [hidden]="order.statusId !== 2 && order.statusId !== 3"
                    >
                        UnApply ACH Pricing
                    </button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-success ms-4" (click)="createInvoice()" [hidden]="order.statusId !== 2 && order.statusId !== 3">
                        Create Invoice
                    </button>
                    <span *ngIf="isCreditOrder" class="ms-4 text-danger fw-bold fs-3 align-middle">CREDIT</span>
                </div>

                <div class="ms-auto d-flex align-items-center">
                    <ng-container *ngIf="order">
                        <label *ngIf="isQuote" class="mt-2 me-2">Include PrePay Pricing</label>
                        <dx-check-box *ngIf="isQuote" class="me-3" [(value)]="order.printPrePayPricing"></dx-check-box>
                        <ng-container *ngIf="!isQuote && !isCreditOrder">
                            <label class="mt-2 me-2">No PrePay Pricing</label>
                            <dx-check-box class="me-3" [(value)]="order.noPrePay"></dx-check-box>
                        </ng-container>
                        <label class="mt-2 me-2">Print Pricing</label>
                        <dx-check-box class="me-3" [(value)]="order.printPricing"></dx-check-box>
                        <label class="mt-2 me-2">Order Date</label>
                        <dx-date-box class="me-3" [(value)]="order.createDate" width="125px"></dx-date-box>
                        <label class="mt-2 me-2">Due Date</label>
                        <dx-date-box class="me-3" [(value)]="order.dueDate" width="125px"></dx-date-box>
                    </ng-container>

                    <label class="dx-box-item-content d-inline-block align-middle ms-4 me-2 mt-1">Status </label>
                    <h3>
                        <strong>{{ order.statusName }}{{ isQuote ? ' Quote' : '' }}</strong>
                    </h3>
                    <button
                        class="btn btn-sm btn-success ms-3"
                        (click)="email('confirmation')"
                        [hidden]="(order.statusId !== 1 && order.statusId !== 6) || showAsDialog || isQuote || isCreditOrder"
                    >
                        {{ order.statusId === 6 ? 'Re-' : '' }}Email Confirmation
                    </button>

                    <button
                        class="btn btn-sm btn-primary ms-3"
                        (click)="isCreditOrder ? submitCredit() : submit()"
                        [disabled]="hasChanges()"
                        [hidden]="(order.statusId !== 1 && order.statusId !== 6) || showAsDialog || isQuote"
                    >
                        Submit
                    </button>
                    <button
                        class="btn btn-sm btn-success ms-3"
                        (click)="complete()"
                        [disabled]="hasChanges()"
                        [hidden]="order.statusId !== 2 || showAsDialog || isQuote || isCreditOrder"
                    >
                        Complete
                    </button>
                    <!-- <button
                        class="btn btn-sm btn-danger ms-3"
                        (click)="unSubmit()"
                        [disabled]="hasChanges()"
                        [hidden]="!canUnSubmit || order.statusId !== 2 || showAsDialog || isQuote"
                    >
                        UnSubmit Entire Sales Order
                    </button> -->
                </div>
            </div>

            <dx-form [formData]="order" [colCount]="12" validationGroup="mainValidationGroup">
                <dxi-item itemType="group" caption="Dealer" [colSpan]="3" [colCount]="1">
                    <dxi-item *ngIf="order" [label]="{ text: 'Type' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="order.typeId"
                                [items]="orderTypes"
                                valueExpr="id"
                                displayExpr="name"
                                (onValueChanged)="onTypeSelectionChange($event)"
                                [readOnly]="readOnly || showAsDialog || startCredit"
                            >
                            </dx-select-box>
                        </div>
                        <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                        <dxi-validation-rule type="range" [min]="'1'" [message]="'Required'"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item *ngIf="order" [label]="{ text: 'Dealer' }">
                        <div *dxTemplate>
                            <div class="d-flex">
                                <dx-select-box
                                    class="flex-fill"
                                    [(value)]="order.dealerId"
                                    [items]="dealers"
                                    valueExpr="id"
                                    displayExpr="companyName"
                                    [searchEnabled]="true"
                                    searchMode="startswith"
                                    (onValueChanged)="dealerSelectionChanged($event)"
                                    [readOnly]="readOnly || showAsDialog"
                                >
                                </dx-select-box>
                                <button *ngIf="isQuote && !readOnly && !showAsDialog" class="btn btn-sm btn-success ms-2" (click)="addDealer()">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </div>
                        <dxi-validation-rule type="required" [message]="'Dealer Required'"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item *ngIf="!isCreditOrder" [label]="{ text: 'Ship Location' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="order.shipAddressId"
                                [items]="shipAddresses"
                                valueExpr="id"
                                [displayExpr]="locationDisplay"
                                [searchEnabled]="true"
                                (onValueChanged)="copyShipping($event)"
                                [disabled]="order.dealer?.shipSameAsBilling || shipAddresses.length === 0"
                                [placeholder]="order.dealer ? (order.dealer.shipSameAsBilling || shipAddresses.length === 0 ? 'Same As Billing' : 'Select...') : 'Set Dealer...'"
                                [readOnly]="!canChangeShipAddress || showAsDialog"
                            ></dx-select-box>
                        </div>
                        <dxi-validation-rule
                            *ngIf="order?.dealer?.shipSameAsBilling || order?.dealer?.shipAddresses.length !== 0"
                            type="required"
                            [message]="'Ship Address Required'"
                        ></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item itemType="group" [colSpan]="1" [colCount]="2">
                        <dxi-item dataField="invoiceNumber" [label]="{ text: 'Sales Order #' }" [editorOptions]="{ readOnly: showAsDialog }"></dxi-item>
                        <dxi-item dataField="pONumber" [label]="{ text: 'PO Number' }" [editorOptions]="{ readOnly: showAsDialog }"> </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colSpan]="1" [colCount]="1">
                        <!-- <dxi-item
                            *ngIf="canSeeSales"
                            dataField="currentYTDSales"
                            [label]="{ text: 'Dealer Total' }"
                            editorType="dxNumberBox"
                            [editorOptions]="{ disabled: true, format: '$#,##0.00' }"
                        >
                        </dxi-item> -->

                        <dxi-item *ngIf="order && canSeePricingTier" [label]="{ text: 'Pricing Tier' }" class="tier-dealer-override">
                            <div *dxTemplate>
                                <dx-select-box
                                    [ngClass]="{
                                        'tier-dealer-override': !!order.dealer?.pricingTierId ? true : false,
                                        'tier-manual-override': !order.dealer?.pricingTierId && order._salesBasedTierId !== order.pricingTierId ? true : false,
                                    }"
                                    [(value)]="order.pricingTierId"
                                    [items]="pricingTiers"
                                    valueExpr="id"
                                    displayExpr="name"
                                    [disabled]="readOnly"
                                    [readOnly]="readOnly"
                                    (onValueChanged)="pricingTierSelectionChanged($event)"
                                >
                                </dx-select-box>
                            </div>
                            <dxi-validation-rule *ngIf="canSeeSales" type="required" [message]="'Required'"></dxi-validation-rule>
                        </dxi-item>
                    </dxi-item>
                </dxi-item>

                <dxi-item *ngIf="!isCreditOrder" itemType="group" caption="Ship Address" [colSpan]="2" [colCount]="1">
                    <dxi-item>
                        <div class="mb-1" *dxTemplate>
                            <div class="mt-1 d-flex justify-content-between">
                                <h3 class="mt-0 mb-0">{{ order?.shipCompanyName }}</h3>
                                <i class="fa fa-pencil" style="font-size: '20px'" (click)="editShipAddress()" [title]="'Edit Ship Info'"></i>
                            </div>
                            <h3 class="mt-0 mb-1">{{ order?.shipToLocation }}</h3>
                            <div>{{ order?.shipToAddress1 }}</div>
                            <div>{{ order?.shipToAddress2 }}</div>
                            <div>
                                {{ order?.shipToCity?.trim() }}{{ order?.shipToCity && ', ' }}
                                {{ order?.shipToState }}
                                {{ order?.shipToZip }}
                                {{ order?.shipToCountry }}
                            </div>
                            <div>{{ order?.shipToPhone }}</div>
                            <div>{{ order?.shipToEmail }}</div>
                            <div class="mt-1 d-flex justify-content-between">
                                <h4 *ngIf="order?.salesRep?.displayName" class="mt-2 mb-0">Sales Rep {{ order?.salesRep?.displayName }}</h4>
                                <i *ngIf="canChangeSalesRep" class="fa fa-pencil" style="font-size: '20px'" (click)="changeSalesRep()" [title]="'Change Sales Rep'"></i>
                            </div>
                            <div *ngIf="order?.loadedMiles" class="mt-2 mb-0">Loaded Miles: {{ order?.loadedMiles }}</div>
                            <div>{{ `Standard Freight: $${(mileageRate * order?.loadedMiles | number: '1.2-2')}` }}</div>
                            <div>{{ `Discounted Freight: $${(discountMileageRate * order?.loadedMiles | number: '1.2-2')}` }}</div>
                        </div>
                    </dxi-item>
                    <dxi-item
                        *ngIf="canSeeSales"
                        dataField="currentYTDSales"
                        [label]="{ text: 'Dealer Total' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ disabled: true, format: '$#,##0.00' }"
                    >
                    </dxi-item>
                    <!-- <dxi-item [label]="{ text: 'Est. Freight' }">
                        <div *dxTemplate class="d-flex">
                            <dx-number-box [(value)]="calculatedFreight" format="$#,##0.00" [disabled]="true"> </dx-number-box>
                            <i class="ms-2 mt-2 fa fa-copy" style="font-size: '20px'" (click)="copyFreight()" [title]="'Copy to Freight'"></i>
                        </div>
                    </dxi-item> -->

                    <!-- <dxi-item *ngIf="allowFreightEntry" [label]="{ text: 'Freight' }" cssClass="input-right">
                        <div *dxTemplate>
                            <dx-number-box [(value)]="order.freight" format="$#,##0.00" (onValueChanged)="freightChange($event)" [readOnly]="showAsDialog"> </dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="!allowFreightEntry" dataField="freightDisplay" [label]="{ text: 'Freight' }"></dxi-item> -->
                </dxi-item>

                <dxi-item itemType="group" caption="Info" [colSpan]="2">
                    <dxi-item
                        dataField="paymentMethod"
                        [label]="{ text: 'Method' }"
                        editorType="dxSelectBox"
                        [editorOptions]="{ items: paymentMethods, valueExpr: 'name', displayExpr: 'name', readOnly: showAsDialog }"
                    ></dxi-item>

                    <dxi-item [label]="{ text: 'Delivery' }" *ngIf="order && !isCreditOrder">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="order.deliveryOptionId"
                                [items]="deliveryOptions"
                                valueExpr="id"
                                displayExpr="name"
                                (onValueChanged)="deliveryOptionSelectionChanged($event)"
                                [readOnly]="showAsDialog"
                            >
                            </dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="dealerDeliveryConfirmationEnabled && !isCreditOrder" [label]="{ text: 'Requested Delivery' }">
                        <div *dxTemplate>
                            <dx-select-box [value]="order.dealerDeliveryOptionId" [items]="deliveryOptions" valueExpr="id" displayExpr="name" placeholder="" [readOnly]="true">
                            </dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item *ngIf="isWarranty" dataField="deliverer" [label]="{ text: 'Packaged By' }"> </dxi-item>

                    <dxi-item *ngIf="order.deliveryOptionId === 3 && !isCreditOrder" [label]="{ text: 'Tracking #' }">
                        <div *dxTemplate>
                            <dx-text-box [(value)]="order.trackingNumber" [readOnly]="readOnly"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item
                        *ngIf="isWinterOrder"
                        dataField="winterDownPayment"
                        [label]="{ text: '10% Down' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Order Total" [colSpan]="2">
                    <dxi-item
                        dataField="originalTotal"
                        [label]="{ text: 'Original' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item
                        *ngIf="!isWarranty && !isCreditOrder"
                        dataField="discountAmount"
                        [label]="{ text: 'Discount' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item dataField="subTotal" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
                    <dxi-item *ngIf="isRetail" dataField="tax" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
                    <dxi-item dataField="total" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>

                    <dxi-item
                        *ngIf="canSeeACH && !isWarranty && !isCreditOrder && !this.order?.dealer?.channelPartner"
                        dataField="achDiscountAmountDisplay"
                        [label]="{ text: 'w/ Pre-Pay' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true, disabled: true }"
                    ></dxi-item>
                    <dxi-item *ngIf="order && canSeeACH && !isWarranty && !isCreditOrder && this.order?.dealer?.channelPartner" [label]="{ text: 'w/ Pre-Pay' }">
                        <span *dxTemplate class="d-flex align-items-center">
                            <dx-number-box [value]="order?.achDiscountAmountDisplay" [format]="'$#,##0.00##'" [readOnly]="true" [disabled]="true"></dx-number-box>
                            <i
                                class="ms-2 fa fa-exclamation-triangle"
                                style="font-size: '20px'"
                                [title]="`Pre-Pay discount is only eligible for non 'Channel Partner' dealers.`"
                            ></i>
                        </span>
                    </dxi-item>

                    <dxi-item
                        *ngIf="!isCreditOrder"
                        dataField="freightTotal"
                        [label]="{ text: 'Freight Total' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                    ></dxi-item>
                </dxi-item>

                <!-- Attachments and Confirmations -->
                <dxi-item itemType="group" [colSpan]="3" [colCount]="1">
                    <dxi-item itemType="group" caption="Attachments">
                        <dxi-item>
                            <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="orderAttachments">
                                <li *ngFor="let attachment of orderAttachments">
                                    <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                    <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                </li>
                            </ul>
                        </dxi-item>
                        <dxi-item>
                            <div *dxTemplate>
                                <dx-file-uploader
                                    name="fileUpload"
                                    selectButtonText="Select File(s)"
                                    class="attachments"
                                    accept="*"
                                    uploadMode="instantly"
                                    [showFileList]="false"
                                    [multiple]="true"
                                    [uploadUrl]="uploadUrl"
                                    [uploadHeaders]="uploadHeader"
                                    (onUploadStarted)="uploadStarted($event)"
                                    (onUploadError)="uploadError($event)"
                                    (onUploaded)="uploaded($event)"
                                >
                                </dx-file-uploader>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item *ngIf="!isCreditOrder" itemType="group" caption="Confirmations">
                        <dxi-item>
                            <div *dxTemplate>
                                <div *ngFor="let confirmation of dealerConfirmations">
                                    <span>
                                        <a [routerLink]="[]" (click)="openConfirmation(confirmation.code)">{{ confirmation.code }}</a>
                                        {{
                                            confirmation.approved
                                                ? ' - Approved - ' + (confirmation.approved | date: 'MM/dd/yy')
                                                : confirmation.declined
                                                  ? ' - Declined - ' + (confirmation.declined | date: 'MM/dd/yy')
                                                  : ''
                                        }}
                                    </span>
                                </div>
                            </div>
                        </dxi-item>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <!-- OrderLines Data Grid -->
    <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }" *ngIf="!isCreditOrder">
        <dx-data-grid
            #linesGrid
            height="200"
            [dataSource]="orderLines"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="onOrderLineSelectionChanged($event)"
            (onRowUpdated)="onRowUpdating($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onExporting)="onExporting($event)"
            class="lines-grid"
        >
            <dxi-column dataField="displayOrder" [visible]="false" width="100"></dxi-column>
            <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="false" width="65"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" [allowEditing]="false" width="200" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="description" caption="Description" [allowEditing]="false" width="400"></dxi-column>
            <dxi-column dataField="note" caption="Note" width="150" [allowEditing]="true"></dxi-column>
            <dxi-column
                dataField="quotedPrice"
                caption="Quoted Price"
                width="100"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column
                dataField="part.retailPrice"
                caption="Retail"
                width="80"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column
                dataField="originalPrice"
                caption="Dealer Price"
                width="80"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column
                *ngIf="canSeeACH"
                dataField="achLineAmount"
                caption="ACH Price"
                width="80"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column
                dataField="price"
                [editorOptions]="{ step: 0 }"
                caption="Tier Price"
                width="100"
                [allowEditing]="false"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
            ></dxi-column>

            <dxi-column dataField="lineTotal" caption="Total" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="tax" caption="Tax" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column
                dataField="detailTotal"
                caption="Detail Total"
                width="100"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>

            <dxi-column
                dataField="detailPaymentTotal"
                caption="Payments"
                width="100"
                alignment="right"
                [format]="{ type: 'currency', precision: 2 }"
                [allowEditing]="false"
            ></dxi-column>
            <dxi-column dataField="orderLineDetailList" caption="Details" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="orderLineDetailStatuses" caption="Statuses" width="100" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="vinDisplay" caption="VIN #" width="250" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="paidAch" *ngIf="canSeeACH" caption="ACH Date" width="250" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="lineNumber" caption="Line #" width="100" [sortIndex]="0" [sortOrder]="'asc'" [allowEditing]="false"></dxi-column>
            <dxi-column width="100"></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <div class="parent-part-number" *ngIf="!cell.data.deleted && cell.data.partId && !cell.data.parentLineId && !cell.data.isReplacement">{{ cell.text }}</div>
                <div class="replacement-part-number" *ngIf="!cell.data.deleted && cell.data.isReplacement">{{ cell.text }}</div>
                <div class="misc-part-number" *ngIf="!cell.data.deleted && !cell.data.partId && !cell.data.isReplacement && !cell.data.isCredit">{{ cell.text }}</div>
                <div class="credit-part-number" *ngIf="!cell.data.deleted && cell.data.isCredit">{{ cell.text }}</div>
                <div class="option-part-number" *ngIf="!cell.data.deleted && cell.data.parentLineId">{{ cell.text }}</div>
                <div class="waiting-to-submit-part-number" *ngIf="!cell.data.deleted && orderEditedAfterSubmit && !cell.data.submitted">{{ cell.text }}</div>
                <div class="deleted-line" *ngIf="cell.data.deleted">{{ cell.text }}</div>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-sm btn-secondary"
                    (click)="moveLine(linesGrid.instance.getSelectedRowsData()[0], 'up')"
                    [hidden]="(order.statusId !== 1 && order.statusId !== 2 && order.statusId !== 6) || showAsDialog"
                    [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    <i class="fa fa-long-arrow-up"></i>
                </button>
                <button
                    class="btn btn-sm btn-secondary ms-1 me-2"
                    (click)="moveLine(linesGrid.instance.getSelectedRowsData()[0], 'down')"
                    [hidden]="(order.statusId !== 1 && order.statusId !== 2 && order.statusId !== 6) || showAsDialog"
                    [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    <i class="fa fa-long-arrow-down"></i>
                </button>
                <button accesskey="t" class="btn btn-sm btn-secondary me-2" (click)="addLines('Trailers')" [hidden]="showAsDialog && !isCreditOrder">Add Trailer(s)</button>
                <button
                    accesskey="o"
                    class="btn btn-sm btn-secondary me-2"
                    (click)="addLines('Options')"
                    [hidden]="showAsDialog && !isCreditOrder"
                    [disabled]="
                        linesGrid.instance.getSelectedRowsData().length !== 1 ||
                        linesGrid.instance.getSelectedRowsData()[0].isOption ||
                        linesGrid.instance.getSelectedRowsData()[0].isReplacement ||
                        !linesGrid.instance.getSelectedRowsData()[0].partId
                    "
                >
                    Add Option(s)
                </button>
                <button accesskey="r" class="btn btn-sm btn-secondary me-4" (click)="addLines('Replacements')" [hidden]="showAsDialog && !isCreditOrder">
                    Add Replacement Part(s)
                </button>
                <button accesskey="m" class="btn btn-sm btn-secondary me-2" (click)="addMiscLine()" [hidden]="showAsDialog && !isCreditOrder">Misc Line</button>
                <button
                    class="btn btn-sm btn-secondary me-2"
                    (click)="removeOrderLine()"
                    [hidden]="showAsDialog && !isCreditOrder"
                    [disabled]="linesGrid.instance.getSelectedRowsData().length === 0 || linesGrid.instance.getSelectedRowsData()[0].submitted"
                >
                    Remove
                </button>
                <button
                    class="btn btn-sm btn-success me-2"
                    (click)="splitLine()"
                    [disabled]="
                        linesGrid.instance.getSelectedRowsData().length !== 1 ||
                        linesGrid.instance.getSelectedRowsData()[0].parentLineId !== null ||
                        linesGrid.instance.getSelectedRowsData()[0].quantity <= 1
                    "
                    [hidden]="order.statusId !== 2 || showAsDialog"
                >
                    Split Line
                </button>
                <button
                    class="btn btn-sm btn-success me-2"
                    (click)="updateLineQuantity()"
                    [hidden]="showAsDialog && !isCreditOrder"
                    [disabled]="
                        linesGrid.instance.getSelectedRowsData().length !== 1 ||
                        linesGrid.instance.getSelectedRowsData()[0].parentLineId !== null ||
                        linesGrid.instance.getSelectedRowsData()[0].submitted
                    "
                >
                    Update Qty
                </button>
                <button
                    class="btn btn-sm btn-success me-2"
                    (click)="updateLinePrice()"
                    [hidden]="!canUpdatePricing || (showAsDialog && !isCreditOrder)"
                    [disabled]="!canUpdatePricing || linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Update Pricing
                </button>
                <button class="btn btn-sm btn-success me-2" (click)="addVINAsBuildDetail()" [hidden]="order.statusId !== 2 || showAsDialog">Add VIN(s)</button>
                <button class="btn btn-sm btn-danger ms-2" (click)="partNumberGenerator()" [hidden]="showAsDialog">Part Number Generator</button>
                <button
                    class="btn btn-sm btn-success ms-4 me-2"
                    (click)="editDescription(linesGrid.instance.getSelectedRowsData()[0])"
                    [hidden]="showAsDialog"
                    [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Edit Desc
                </button>

                <button
                    class="btn btn-sm btn-primary ms-5 me-2"
                    (click)="submitSingleLine()"
                    [hidden]="showAsDialog || !canEditSubmittedOrders || !orderEditedAfterSubmit"
                    [disabled]="
                        order.statusId === 1 ||
                        order.statusId === 6 ||
                        linesGrid.instance.getSelectedRowsData().length !== 1 ||
                        linesGrid.instance.getSelectedRowsData()[0].isOption ||
                        !orderLineCanBeSubmitted
                    "
                >
                    Submit New Line
                </button>

                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="removeOrderLineAfterSubmit()"
                    [hidden]="showAsDialog || !canEditSubmittedOrders || order.statusId === 1 || order.statusId === 6"
                    [disabled]="order.statusId === 1 || order.statusId === 6 || linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Remove After Submit
                </button>
            </div>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-editing [mode]="'cell'" [allowUpdating]="!readOnly && !showAsDialog"></dxo-editing>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-state-storing [enabled]="true" [storageKey]="'order-detail-grid'"></dxo-state-storing>
            <dxo-sorting [mode]="'none'"></dxo-sorting>
        </dx-data-grid>
    </div>

    <!-- Credit OrderLines Data Grid -->
    <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }" *ngIf="isCreditOrder">
        <dx-data-grid
            #linesGrid
            height="200"
            [dataSource]="orderLines"
            keyExpr="id"
            [columnAutoWidth]="false"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="onOrderLineSelectionChanged($event)"
            (onRowUpdated)="onRowUpdating($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onExporting)="onExporting($event)"
            class="lines-grid"
        >
            <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="false" width="65"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" [allowEditing]="false" width="200" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="description" caption="Description" [allowEditing]="false" width="400"></dxi-column>
            <dxi-column dataField="price" caption="Price" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="lineTotal" caption="Total" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="returnedDetail.vIN" caption="VIN #" width="165" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="returnedDetail.invoiceNumberDisplay" caption="Invoice #" width="100" [allowEditing]="false" cellTemplate="invoiceLinkTemplate"></dxi-column>
            <dxi-column dataField="creditRestock" caption="Restock" width="80" cellTemplate="restockTemplate" [allowEditing]="false"></dxi-column>
            <dxi-column dataField="note" caption="Note" width="150" [allowEditing]="true"></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <div class="parent-part-number" *ngIf="!cell.data.deleted && cell.data.partId && !cell.data.returnedDetailId">{{ cell.text }}</div>
                <div class="replacement-part-number" *ngIf="!cell.data.deleted && cell.data.returnedDetailId">{{ cell.text }}</div>
                <div class="misc-part-number" *ngIf="!cell.data.deleted && !cell.data.partId && !cell.data.returnedDetailId">{{ cell.text }}</div>
                <div class="deleted-line" *ngIf="cell.data.deleted">{{ cell.text }}</div>
            </div>

            <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
                <a *ngIf="cell.data.returnedDetail?.invoiceId" [routerLink]="'/invoices/' + cell.data.returnedDetail.invoiceId">{{ cell.text }}</a>
            </div>

            <div *dxTemplate="let cell of 'restockTemplate'">
                <dx-check-box *ngIf="cell.data.returnedDetailId" [(value)]="cell.data.creditRestock" [readOnly]="readOnly"></dx-check-box>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-sm btn-secondary me-2" (click)="addPartLine()" [hidden]="readOnly">Add Part</button>
                <button class="btn btn-sm btn-secondary me-2" (click)="addMiscLine()" [hidden]="readOnly">Misc Line</button>
                <button class="btn btn-sm btn-secondary me-2" (click)="importFromInvoice()" [hidden]="readOnly" [disabled]="!order.dealerId">Import from Invoice</button>
                <button
                    class="btn btn-sm btn-success me-2"
                    (click)="updateLineQuantity()"
                    [disabled]="
                        readOnly ||
                        linesGrid.instance.getSelectedRowsData().length !== 1 ||
                        linesGrid.instance.getSelectedRowsData()[0].parentLineId !== null ||
                        linesGrid.instance.getSelectedRowsData()[0].submitted ||
                        !!linesGrid.instance.getSelectedRowsData()[0].returnedDetailId
                    "
                >
                    Update Qty
                </button>
                <button
                    class="btn btn-sm btn-success me-2"
                    (click)="updateLinePrice()"
                    [hidden]="!canUpdatePricing"
                    [disabled]="!canUpdatePricing || readOnly || linesGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Update Pricing
                </button>
            </div>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-editing [mode]="'cell'" [allowUpdating]="!readOnly && !showAsDialog"></dxo-editing>
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" [storageKey]="'order-detail-credit-grid'"></dxo-state-storing>
            <dxo-sorting [mode]="'none'"></dxo-sorting>
            <dxo-summary>
                <dxi-total-item column="lineTotal" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
            </dxo-summary>
        </dx-data-grid>
    </div>

    <div class="card">
        <div class="card-body">
            <dx-form #totalsForm [formData]="order" [colCount]="4">
                <dxi-item itemType="group" [colSpan]="2">
                    <dxi-item [label]="{ text: 'Internal Notes' }">
                        <div *dxTemplate>
                            <dx-text-area [(value)]="order.note" [height]="100"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" [colSpan]="2">
                    <dxi-item [label]="{ text: 'Order Notes (visible to dealer)' }">
                        <div *dxTemplate class="d-flex align-items-start">
                            <dx-text-area [(value)]="order.shippingNote" [height]="100" class="flex-fill"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button *ngIf="orderId === 'invoice-credit'" class="btn btn-success ms-1" (click)="closeDialog(true)">Create Credit</button>
    <button class="btn btn-secondary ms-1" (click)="closeDialog()">Close</button>
</div>
